import React, { useState, useEffect, useRef } from "react";
import { SocialShare } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";
import { object, string, bool, func } from "prop-types";

import SocialShareTemplate from "../SocialShareTemplate";
import { FontIncrease, FontDecrease, CommentIcon, Share } from "../../atoms/icons/StoryPageIcons";
import { setMetypeBar } from "../../helper/actions";
import ShareAllTemplate from "../ShareAllTemplate";

import "./storyPageMetaDataIcons.m.css";
import BookmarkViewIcon from "../../atoms/BookmarkViewIcon";

const StoryPageMetaDataIcons = ({
  storyData,
  color1 = "#eee",
  color2 = "#222",
  isMetypeBar,
  setMetypeBar,
  isVideoStory,
  publisherAttributes
}) => {
  const [elements, setElements] = useState(null);
  const [customGalleryElements, setCustomGalleryElements] = useState(null);
  const [fontIncHover, setFontIncHover] = useState(false);
  const [fontDecHover, setFontDecHover] = useState(false);
  const [isSocialShare, setSocialShare] = useState(false);
  const ref = useRef(null);

  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      setSocialShare(false);
    }
  };

  useEffect(() => {
    if (global.deviceWidth > 876) {
      document.addEventListener("click", handleClickOutside, true);
      return () => {
        document.removeEventListener("click", handleClickOutside, true);
      };
    }
  });

  useEffect(() => {
    setElements(document.getElementsByClassName("story-element-text"));
    setCustomGalleryElements(document.getElementsByClassName("custom-galley-image"));
  }, []);

  const fontIncrease = () => {
    Array.from(elements).forEach(element => processFontStyle("add", element));
    Array.from(customGalleryElements).forEach(element => processFontStyle("add", element));
  };

  const fontDecrease = () => {
    Array.from(elements).forEach(element => processFontStyle("minus", element));
    Array.from(customGalleryElements).forEach(element => processFontStyle("minus", element));
  };

  const processFontStyle = (type, element) =>
    (element.style.fontSize =
      type === "add"
        ? parseFloat(getComputedStyle(element).fontSize) / 10 + 0.2 + "em"
        : parseFloat(getComputedStyle(element).fontSize) / 10 - 0.2 + "em");

  const renderMetype = () => setMetypeBar(!isMetypeBar);
  const changeFontIncrease = () => {
    setFontIncHover(!fontIncHover);
  };

  const changeFontDecrease = () => {
    setFontDecHover(!fontDecHover);
  };

  const toggleShare2 = () => {
    setSocialShare(!isSocialShare);
  };

  return (
    <div styleName="icons" className="meta-data-icons">
      <SocialShare
        template={SocialShareTemplate}
        title={storyData.headline}
        url={storyData.slug}
        color1={color1}
        color2={color2}
      />
      <span styleName="share-button" ref={ref}>
        <span onClick={toggleShare2}>
          <Share color1={color1} color2={color2} />
        </span>
        {isSocialShare && (
          <SocialShare
            template={ShareAllTemplate}
            title={storyData.headline}
            fullUrl={encodeURI(storyData.url)}
            toggleShare2={toggleShare2}
            onScroll={true}
          />
        )}
      </span>
      {!isVideoStory && (
        <span
          onClick={fontIncrease}
          className="font-increase"
          onMouseEnter={changeFontIncrease}
          onMouseLeave={changeFontIncrease}
        >
          <FontIncrease className="font-increase" lang={publisherAttributes.lang} />
        </span>
      )}
      {!isVideoStory && (
        <span
          onClick={fontDecrease}
          className="font-decrease"
          onMouseEnter={changeFontDecrease}
          onMouseLeave={changeFontDecrease}
        >
          <FontDecrease className="font-decrease" lang={publisherAttributes.lang} />
        </span>
      )}
      {publisherAttributes.showBookmark && (
        <span className="bookmark">
          {/* <Bookmark color1={color1} color2={color2} /> */}
          <BookmarkViewIcon story={storyData.story} />
        </span>
      )}
      {publisherAttributes.showMetype && (
        <span className="comment-icon" onClick={renderMetype}>
          <CommentIcon className="comment-icon" />
        </span>
      )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    storyData: get(state, ["headerReducer", "showStoryHeader"], ""),
    isMetypeBar: get(state, ["metypeReducer", "isMetypeBar"], false),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

const mapDispatchToProps = dispatch => ({
  setMetypeBar: flag => dispatch(setMetypeBar(flag))
});

export default connect(mapStateToProps, mapDispatchToProps)(StoryPageMetaDataIcons);

StoryPageMetaDataIcons.propTypes = {
  storyData: object,
  color1: string,
  color2: string,
  isMetypeBar: bool,
  isVideoStory: bool,
  setMetypeBar: func,
  publisherAttributes: object
};
